import * as yup from 'yup';

export const initialValues = {
  type: '',
  frontFile: '',
  imageTooLarge: false,
  tempFile: {
    uuid: '',
    file: null,
    type: '',
  },
};

export const validationSchema = yup.lazy(() =>
  yup.object().shape({
    type: yup.string().required(),
    tempFile: yup
      .object()
      .shape({
        uuid: yup.string().required(),
      })
      .required(),
    imageTooLarge: yup.boolean().oneOf([false], 'File must be 5MB or less').required(),
  })
);
